//
// UserAgent解析
//
function device (userAgent) {
  userAgent = userAgent.toLowerCase()
  if (userAgent.indexOf('iphone') !== -1) {
    return 'iPhone'
  } else if (userAgent.indexOf('ipad') !== -1) {
    return 'iPad'
  } else if (userAgent.indexOf('android') !== -1) {
    if (userAgent.indexOf('mobile') !== -1) {
      return 'Android'
    } else {
      return 'Android Tablet'
    }
  } else {
    return 'PC'
  }
}

function browser (userAgent) {
  userAgent = userAgent.toLowerCase()
  if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
    return 'Internet Exploler'
  } else if (userAgent.indexOf('edge') !== -1) {
    return 'Microsoft Edge'
  } else if (userAgent.indexOf('chrome') !== -1) {
    return 'Chrome'
  } else if (userAgent.indexOf('safari') !== -1) {
    return 'Safari'
  } else if (userAgent.indexOf('firefox') !== -1) {
    return 'Firefox'
  } else if (userAgent.indexOf('opera') !== -1) {
    return 'Opera'
  } else if (userAgent.indexOf('yjapp')) {
    return 'Yahoo Japan'
  } else {
    return 'Unknown'
  }
}

export default {device: device, browser: browser}


// WEBPACK FOOTER //
// ./src/functions/parseUserAgent.js